import { Project } from '~screens/Dashboard/screens/Projects/types';
import api from '../config/api';

export interface Country {
    id: number;
    name: string;
    flag?: string;
}

export interface Route {
    id: number;
    name: string;
    description: string;
    countries: Country;
    countriesFormatted: string;
    kmz: string;
    totalInvestmentFormatted: string;
    projects: number;
    uuid: string;
    projectsList?: Project[];
    ajusteMapa?: {
        latitude: string,
        longitude: string,
        zoom: number
    }
}


export const getRoutes = () => api.get('/routes/all').then(response => {
    return response.data as Route[];
}); // eslint-disable-line camelcase

export const getRouteProjects = (routeId: number | string) => api.get(`/routes/${routeId}/projects/`).then(response => {
    return response.data as Route;
});